export default __webpack_public_path__ + "static/media/bogota.aa692364.png";